import { render, staticRenderFns } from "./basicSetting.vue?vue&type=template&id=67410a3e&scoped=true&"
import script from "./basicSetting.vue?vue&type=script&lang=js&"
export * from "./basicSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67410a3e",
  null
  
)

export default component.exports